import router from '@/router/index'

const state = {
  idCurrentUser: null,
  fetchedMe: false
}

const getters = {
  currentUser: (state, getters) => {
    if (!state.idCurrentUser) return {}
    return getters.query().where('id', state.idCurrentUser).withAllRecursive().first()
  },
  id: state => state.idCurrentUser,
  isConnected: (state, getters) => !!(getters.currentUser && getters.currentUser.id && getters.currentUser.name)
}

const actions = {
  async login ({ commit, dispatch }, { password, email }) {
    // demo local data
    dispatch('fetchMe')
    router.push({ name: 'home' })
    return
    // demo local data
    if (!password || !email) return
    let returnValue = {}
    try {
      const result = await this.getters.api.post('/oauth/token', {
        data: {
          client_id: 'fafe594f2662ea650a6e8f3bb8458dcf122ab478e482ce63854262e23364eb4e',
          client_secret: '1a1c0795ac82a6707d189c4c127af01648412b20355fef40009a8b462dbf010e',
          grant_type: 'password',
          password: password,
          username: email
        }
      })
      if (!result || !result.data) return
      localStorage.accessToken = result.data.access_token
      localStorage.createdAt = result.data.created_at
      localStorage.expiresIn = result.data.expires_in
      localStorage.refreshToken = result.data.refresh_token
      localStorage.tokenType = result.data.token_type || 'Bearer'

      await dispatch('fetchMe')
      router.push({ name: 'home' })
      returnValue = { success: true }
    } catch (e) {
      returnValue = { error: 'Bad credentials' }
    }
    return returnValue
  },
  async refreshToken ({ commit, dispatch }, { refreshToken }) {
    if (!refreshToken) return
    try {
      const result = await this.getters.api.post('/oauth/token', {
        data: {
          client_id: 'fafe594f2662ea650a6e8f3bb8458dcf122ab478e482ce63854262e23364eb4e',
          client_secret: '1a1c0795ac82a6707d189c4c127af01648412b20355fef40009a8b462dbf010e',
          grant_type: 'refresh_token',
          refresh_token: refreshToken
        }
      })
      if (!result || !result.data) return
      localStorage.accessToken = result.data.access_token
      localStorage.createdAt = result.data.created_at
      localStorage.expiresIn = result.data.expires_in
      localStorage.refreshToken = result.data.refresh_token
      localStorage.tokenType = result.data.token_type || 'Bearer'

      await dispatch('fetchMe')

      router.push({ name: 'home' })
    } catch (e) {
      console.log('test', e)
      throw e
    }
  },
  async fetchMe ({ commit, dispatch, state }) {
    // local test
    dispatch('insertOrUpdate', { data: [{
      id: 1,
      name: 'Testeur'
    }] })
    commit('id', 1)
    commit('fetchedMe', true)
    return
    // local test
    if (state.fetchedMe === true) return
    try {
      const itsMe = await this.getters.api.get('/me')
      if (!itsMe || !itsMe.data || !itsMe.data.me) return
      commit('id', itsMe.data.me.id)
      dispatch('create', { data: [itsMe.data.me] })
      commit('fetchedMe', true)
      return itsMe
    } catch (e) {
      throw e
    }
  },
  async logout ({ commit, store }) {
    delete localStorage.accessToken
    delete localStorage.createdAt
    delete localStorage.expiresIn
    delete localStorage.refreshToken
    delete localStorage.tokenType
    commit('id', null)
    this.dispatch('reset')
    router.push({ name: 'login' })
  },
  async signup ({ email, lastname, name, password }) {
    if (!email || !lastname || !name || !password) return
    let result = {}
    try {
      await this.getters.api.post('/signup', {
        data: {
          email,
          lastname,
          name,
          password
        }
      })
      result.success = true
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        result.error = e.response.data.error
      }
    }
    return result
  }
}

const mutations = {
  id (state, id) {
    state.idCurrentUser = id
  },
  fetchedMe (state, value) {
    state.fetchedMe = value
  },
  reset (state, initial) {
    Object.keys(initial).forEach(key => {
      state[key] = initial[key]
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
